import Switch from './switch.vue';
export default Switch;


// WEBPACK FOOTER //
// ./src/components/switch/index.js